import { SearchQueryOrderDirection } from "types/generated";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const TEMPLATES_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "templatesFiltersOrder";

export const REFETCH_QUERIES_LIST = [
  "SearchBlueprintVersionedGroups",
  "SearchBlueprintVersionedGroupsSuggestions",
];

export const FILTER_TYPE = "templates";
export const TEMPLATES_LIMIT_STORAGE_KEY = "templatesLimit";
